import React, { useEffect, useState } from 'react'
import './hero.css'
import heroImg from '../../assets/IMG_20230210_170007356_adobe_express (1).png';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import LanguageIcon from '@mui/icons-material/Language';

function Hero() {
      const [scrollPosition, setScrollPosition] = useState(0);
      const [transitionPosition, setTransitionPosition] = useState(0);
      const [moveDown, setMoveDown] = useState(false);
      const [rotation, setRotation] = useState(0);

      useEffect(() => {
        const handleScroll = () => {
          const currentScrollPosition = window.scrollY;
          const scrollDirection = currentScrollPosition > scrollPosition ? 'down' : 'up';
          
          setScrollPosition(currentScrollPosition);
          setMoveDown(scrollDirection === 'down');
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [scrollPosition]);

        useEffect(() => {
          const intervalIncrement = moveDown ? 0.01 : -0.01;
          const animationInterval = setInterval(() => {
            setTransitionPosition(prevScrollPosition => (prevScrollPosition + intervalIncrement + 10) % 10);
          }, 20);
            return () => {
                clearInterval(animationInterval);
            };
        }, [transitionPosition, moveDown]);

        useEffect(() => {
          const rotationIncrement = moveDown ? 2 : -2;
          const interval = setInterval(() => {
            setRotation(prevRotation => (prevRotation + rotationIncrement + 360) % 360);
          }, 50);
      
          return () => clearInterval(interval);
        }, [moveDown]);

        const translateX = -10 * transitionPosition;
  return (
    <div className='hero slide-in-top-animation'>
        <div className="hero-container">
          <div className="big-name">
            <div className="name">
              <div className="name-wrap" style={{ transform: `translateX(${translateX}%) translate3d(0px, 0px, 0px)` }}>
                <h1>
                  Bibhu Prasad Sahoo
                  <span>—</span>
                </h1>
              </div>
              <div className="name-wrap name2" style={{ transform: `translateX(${translateX}%)` }}>
                <h1>
                  Bibhu Prasad Sahoo
                  <span>—</span>
                </h1>
              </div>
            </div>
          </div>
          <div className="hero-f-div f-left">
            <div className="hero-f-cont">
              <div className="hero-f-left">
                Lives in Bhubaneswar
              </div>
              <div className="hero-f-right" style={{transform: `rotate(${rotation}deg)`}}>
              <LanguageIcon sx={{ fontSize: `calc(clamp(3.25em, 7vw, 8em) * .50)` }} />
              </div>
            </div>
          </div>
          <div className="hero-m-div">
            <img src={heroImg} alt='Hero'/>
          </div>
          <div className="hero-f-div f-right">
            <SouthEastIcon sx={{ width: `clamp(1.1em, 1.3vw, 1.25em)` }}/>
            System Engineer @TCS,<br/>
            AI Application Developer
          </div>
        </div>
    </div>
  )
}

export default Hero